import styled from "styled-components";
import designSystemColors from "../../styles";

interface ICommonProps {
  isSelected: boolean;
}

interface IItemContainer extends ICommonProps {
  $hasSocialName: boolean;
}

export const ItemContainer = styled.div<IItemContainer>`
  position: relative;
  max-width: 524px;
  max-height: ${({ $hasSocialName }) => ($hasSocialName ? "130px" : "115px")};
  height: 100%;
  padding: 16px;
  border-radius: 6px;
  border: 2px solid
    ${(props) =>
      props.isSelected
        ? designSystemColors.generalButtons
        : designSystemColors.border.modalDivider};
  margin: 0 26px 15px 26px;
  cursor: pointer;
  transition: border-color 0.3s;
  font-family: Roboto;

  &:hover {
    border-color: ${designSystemColors.generalButtons};
  }
`;

export const Checkmark = styled.div<ICommonProps>`
  position: absolute;
  top: -10px;
  right: -10px;
  width: 24px;
  height: 24px;
  background-color: ${designSystemColors.generalButtons};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid ${designSystemColors.textGeneralButtons};
  visibility: ${(props) => (props.isSelected ? "visible" : "hidden")};
`;

export const Title = styled.h3`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  color: ${designSystemColors.grayTitle};
`;

export const TitleIcon = styled.img`
  width: 20px;
  margin-right: 8px;
`;

export const Info = styled.p`
  margin: 4px 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;

export const InfoLabel = styled.strong`
  font-weight: 600;
`;
